import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import JobGroup from './JobGroup';
import Clifton from './Clifton';
import PVQ from './PVQ';
import useStyles from './useStyles';
import Weakness from './Weakness';
import UsersResume from './UsersResume';

const Reports = () => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => setTabValue(newValue);

  const getTabContent = () => {
    switch (tabValue) {
      case 0:
        return <JobGroup />;
      case 1:
        return <Clifton />;
      case 2:
        return <PVQ />;
      case 3:
        return <Weakness />;
      case 4:
        return <UsersResume />;
      default:
        return <span />;
    }
  };

  return (
    <Box className={classes.mainContainer}>
      <Tabs
        color='primary'
        classes={{ root: classes.tabsRoot }}
        value={tabValue}
        centered
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='scrollable auto tabs example'
      >
        <Tab label='گروه شغلی' />
        <Tab label='استعداد' />
        <Tab label='ارزش ها' />
        <Tab label='مهارت های مورد نیاز سازمان' />
        <Tab label='استخدام افراد غیر سازمانی' />
      </Tabs>

      {getTabContent()}
    </Box>
  );
};

export default Reports;
